import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import error from './modules/error';
import preloader from './modules/preloader';
import company from './modules/company';
import project from './modules/project';
import projectFile from './modules/projectFile';
import stage from './modules/stage';
import contact from './modules/contact';
import notification from './modules/notification';
import tariff from './modules/tariff';
import affiliate from './modules/affiliate';
import payout from './modules/payout';
import push from './modules/push';
import popup from './modules/popup';
import taskList from './modules/taskList';
import closePrevent from './modules/closePrevent';
import draggable from './modules/draggable';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth,
    error,
    preloader,
    company,
    project,
    projectFile,
    stage,
    contact,
    notification,
    tariff,
    affiliate,
    payout,
    push,
    popup,
    taskList,
    closePrevent,
    draggable,
  },
});
